export default __webpack_public_path__ + "static/media/coc_img.856eff68.png";